// src/pages/About.js
import React from 'react';
import styled from 'styled-components';
import aboutImage from '../assets/solar.jpg';

const About = () => {
  return (
    <AboutContainer>
      <HeroSection>
        <HeroImage>
          <img src={aboutImage} alt="Equipe da GF Soluções em projeto solar" />
        </HeroImage>
        <HeroContent>
          <Eyebrow>Sobre a GF Soluções</Eyebrow>
          <Title>Energia solar com engenharia e proximidade</Title>
          <Paragraph>
            A GF Soluções de Engenharia entrega projetos fotovoltaicos completos para residências, empresas e
            indústrias. Nosso compromisso é gerar eficiência energética, economia real e impacto sustentável.
          </Paragraph>
          <Paragraph>
            Trabalhamos com equipes próprias, acompanhamento técnico e comunicação transparente do início ao
            pós-venda.
          </Paragraph>
          <Highlights>
            <HighlightCard>
              <HighlightValue>+500</HighlightValue>
              <HighlightLabel>Projetos realizados</HighlightLabel>
            </HighlightCard>
            <HighlightCard>
              <HighlightValue>15 anos</HighlightValue>
              <HighlightLabel>Experiência em energia</HighlightLabel>
            </HighlightCard>
            <HighlightCard>
              <HighlightValue>24/7</HighlightValue>
              <HighlightLabel>Monitoramento</HighlightLabel>
            </HighlightCard>
          </Highlights>
        </HeroContent>
      </HeroSection>
      <ValuesSection>
        <ValuesHeader>
          <SectionTitle>O que nos move</SectionTitle>
          <SectionSubtitle>
            Unimos tecnologia, engenharia e cuidado com o cliente para garantir projetos duradouros e
            resultados consistentes.
          </SectionSubtitle>
        </ValuesHeader>
        <ValuesGrid>
          <ValueCard>
            <ValueTitle>Missão</ValueTitle>
            <ValueText>
              Levar energia solar de alta performance para quem busca economia e previsibilidade.
            </ValueText>
          </ValueCard>
          <ValueCard>
            <ValueTitle>Visão</ValueTitle>
            <ValueText>
              Ser referência nacional em soluções fotovoltaicas completas e atendimento consultivo.
            </ValueText>
          </ValueCard>
          <ValueCard>
            <ValueTitle>Valores</ValueTitle>
            <ValueText>
              Transparência, excelência técnica e compromisso com resultados sustentáveis.
            </ValueText>
          </ValueCard>
        </ValuesGrid>
      </ValuesSection>
    </AboutContainer>
  );
};

export default About;

// Styled Components

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 48px 24px 80px;
  background: radial-gradient(circle at top, rgba(255, 69, 0, 0.12), transparent 55%),
    ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    gap: 48px;
  }
`;

const HeroImage = styled.div`
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 69, 0, 0.18);
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const Paragraph = styled.p`
  font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin: 0;
  line-height: 1.7;
`;

const Highlights = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-top: 12px;
`;

const HighlightCard = styled.div`
  padding: 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const HighlightValue = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`;

const HighlightLabel = styled.span`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const ValuesSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const ValuesHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`;

const SectionTitle = styled.h3`
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const SectionSubtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin: 0;
  line-height: 1.6;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
`;

const ValueCard = styled.div`
  padding: 20px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ValueTitle = styled.h4`
  margin: 0;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

const ValueText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  line-height: 1.6;
`;
